module.exports = __webpack_public_path__ + "static/media/sell_rating_3.0ae041de.jpg";